var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rn-back-top",class:[_vm.visible ? 'd-inline' : 'd-none'],on:{"click":_vm.scrollToTop}},[_c('Icon',{attrs:{"name":"chevron-up","size":"27"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }